import { render, staticRenderFns } from "./withdrawalTab.vue?vue&type=template&id=66525628&scoped=true&"
import script from "./withdrawalTab.vue?vue&type=script&lang=js&"
export * from "./withdrawalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66525628",
  null
  
)

export default component.exports